// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_L6cdG {
  width: 400px;
  max-width: 100vw;
  max-height: 60vh;
  padding: 16px;
}

.locatorError_cJ2sy {
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/errors/types/VehicleExists.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".form {\n  width: 400px;\n  max-width: 100vw;\n  max-height: 60vh;\n  padding: 16px;\n}\n\n.locatorError {\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_L6cdG`,
	"locatorError": `locatorError_cJ2sy`
};
export default ___CSS_LOADER_EXPORT___;
